import { Converter } from '../types/converter';

export const concentrationSolutionConverter: Converter = {
  id: 'concentrationSolution',
  name: 'Solution Concentration Converter',
  icon: 'Droplets',
  categories: ['engineering', 'chemistry'],
  units: [
    // Base unit
    { name: 'Kilogram/liter', symbol: 'kg/L', factor: 1 },
    { name: 'Gram/liter', symbol: 'g/L', factor: 0.001 },
    { name: 'Milligram/liter', symbol: 'mg/L', factor: 0.000001 },
    { name: 'Part/million (ppm)', symbol: 'ppm', factor: 0.000001 },
    
    // US units
    { name: 'Grain/gallon (US)', symbol: 'gr/gal (US)', factor: 0.0000171 },
    { name: 'Grain/gallon (UK)', symbol: 'gr/gal (UK)', factor: 0.0000143 },
    { name: 'Pound/gallon (US)', symbol: 'lb/gal (US)', factor: 0.119826427 },
    { name: 'Pound/gallon (UK)', symbol: 'lb/gal (UK)', factor: 0.099776373 },
    { name: 'Pound/million gallon (US)', symbol: 'lb/million gal (US)', factor: 1.19826427e-7 },
    { name: 'Pound/million gallon (UK)', symbol: 'lb/million gal (UK)', factor: 9.9776373e-8 },
    { name: 'Pound/cubic foot', symbol: 'lb/ft³', factor: 0.016018463 }
  ]
};
